import i18n from '@/user/plugins/i18n'

/**
 * 교육완료 상태
 * @property {string} applyState 완료(COMPLETED), 진행 예정(PREPARED)
 */
export class CompletedStateInfo {
  constructor(props) {
    this.progressState = props.progressState
  }

  /**
   * 현재 교육완료 상태 다국어 지원
   * @return {string} 완료, 진행 예정
   */
  getProgressState() {
    switch (this.progressState) {
      case 'FINISHED':
        return i18n.global.t('eduCenter.account.state.finish') // 교육 완료
      case 'WAITING_FINISH':
        return i18n.global.t('eduCenter.account.state.waitingFinish') // 교육 완료 대기
      case 'IN_PROGRESS':
        return i18n.global.t('eduCenter.account.state.inProgress') // 교육 중
      case 'PREPARED':
        return i18n.global.t('eduCenter.account.state.prepared') // 교육 전
    }
  }

  getResultState() {
    switch (this.result) {
      case 'COMPLETED':
        return i18n.global.t('eduCenter.account.state.completed')
      case 'NOT_ATTENDED':
        return i18n.global.t('eduCenter.account.state.notAttended')
      case 'NOT_PRACTICED':
      case 'INCOMPLETE':
        return i18n.global.t('eduCenter.account.state.incomplete')
      case 'CANCELED':
        return '-'
    }
  }

  /**
   * 교육 수료 여부
   * @returns {boolean} 수료 여부
   */
  get isCompleted() {
    return this.progressState === 'FINISHED' && this.result === 'COMPLETED'
  }

  get isCanceled() {
    return this.result === 'CANCELED'
  }

  get isFinished() {
    return this.progressState === 'FINISHED'
  }
}
